import API from "./api";

// Inventory API Service

// Get all inventory items
export const getInventory = async () => {
    try {
        return await API.get("/inventory");
    } catch (error) {
        console.error("Error fetching inventory:", error);
        throw error;
    }
};

// Get inventory by product ID
export const getInventoryByProductId = async (productId) => {
    try {
        return await API.get(`/inventory/${productId}`);
    } catch (error) {
        console.error("Error fetching inventory by product ID:", error);
        throw error;
    }
};

// Add new inventory item
export const createInventory = async (inventoryData) => {
    try {
        return await API.post("/inventory/create", inventoryData);
    } catch (error) {
        console.error("Error creating inventory:", error);
        throw error;
    }
};

// Update stock quantity
export const updateInventoryStock = async (productId, quantity) => {
    try {
        return await API.put("/inventory/update-stock", { productId, quantity });
    } catch (error) {
        console.error("Error updating inventory stock:", error);
        throw error;
    }
};

// Get low stock items
export const getLowStockItems = async () => {
    try {
        return await API.get("/inventory/low-stock");
    } catch (error) {
        console.error("Error fetching low stock items:", error);
        throw error;
    }
};// ✅ Update stock quantity for an existing product
export const updateInventory = async (inventoryData) => {
    try {
        return await API.put("/inventory/update-stock", inventoryData);
    } catch (error) {
        console.error("Error updating inventory stock:", error);
        throw error;
    }
};
